export const getReplaysInRange = ({ start, end }, replays) =>
  replays.filter(replay => replay.start >= start && replay.end <= end);
export const getWidthPercent = ({ start, end }, duration) =>
  ((end - start) * 100) / duration;
export const getSkippedWidthPercent = (prev, cur, duration) =>
  getWidthPercent({ start: prev.end, end: cur.start }, duration);
export const toPercentOfDuration = (ts, videoDuration) =>
  (ts * 100) / videoDuration + '%';

export const toPercent = num => (isNaN(num) ? 'n/a' : `${Math.round(num)}%`);
